import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import DefaultDoubleSkeleton from '../../skeletons/default_double_skeleton';
import StatusIcon from '../../../status_icon';

import './property_cell.scss';

const CLASS_NAME = 'property-cell';

const PropertyCell = (props, customProps) => {
  const name = _.get(props, 'name');
  const id = _.get(props, 'id');
  const defaultCell = _.get(customProps, 'defaultCell');
  const withSkeletons = _.get(customProps, 'withSkeletons');
  const withLink = _.get(customProps, 'withLink');
  const shouldShowReadiness = _.get(customProps, 'shouldShowReadiness');

  const readyStatus =
    shouldShowReadiness && _.get(props, 'ready_status.type_property_ready_status');
  const readyStatusCode = _.get(readyStatus, 'code');

  const address = _.join(
    _.compact([_.get(props, 'address1'), _.get(props, 'address2'), _.get(props, 'city')]),
    ', ',
  );

  if (withSkeletons && _.isUndefined(name)) {
    return <DefaultDoubleSkeleton />;
  }

  const content = (
    <>
      <div className={`${CLASS_NAME}__title-wrapper`}>
        <div className={`${CLASS_NAME}__title`}>{name}</div>
        {readyStatus && (
          <StatusIcon className={`${CLASS_NAME}__status-icon`} code={readyStatusCode} />
        )}
      </div>
      <div className={`${CLASS_NAME}__subtitle`}>{address}</div>
    </>
  );

  if (withLink) {
    return (
      <a
        className={classnames(CLASS_NAME, `${CLASS_NAME}--link`, { 'default-cell': defaultCell })}
        href={`/property/${id}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {content}
      </a>
    );
  }

  return <div className={classnames(CLASS_NAME, { 'default-cell': defaultCell })}>{content}</div>;
};

PropertyCell.propTypes = {
  home: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default PropertyCell;
